export default class CheckpointAtivo implements ICheckpointAtivo {
  public codigoAtivo!: string;
  public quantidade!: number;
  public isin?: string;
  constructor(param: ICheckpointAtivo) {
    Object.assign(this, param);
  }

  static fromFirestore(json: any): CheckpointAtivo {
    return new CheckpointAtivo({
      ...json,
    });
  }
}

interface ICheckpointAtivo {
  codigoAtivo: string;
  quantidade: number;
  isin?: string;
}
